import React, { useMemo } from 'react';
import { twMerge } from 'tailwind-merge';
import AgentBadge from 'flow/components/ui-components/AgentBadge';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    makeSelectNumberAgentsLoggedInToQueue,
    makeSelectOwnUserIsLoggedInToQueue,
    selectQueueActiveProfileAvailable,
} from 'flow/selectors/queue-selectors';
import { QueueKey } from 'flow/types/EntityKeys';
import { isEmptyNullOrUndefined } from 'flow/utils';

interface Props {
    queueKey: QueueKey;
    isSelected?: boolean;
}
const AgentsLoggedInToQueueCount = ({ queueKey, isSelected }: Props) => {
    const selectNumberOfAgentsLoggedInToQueue = useMemo(
        makeSelectNumberAgentsLoggedInToQueue,
        [],
    );
    const numberOfAgentsLoggedInToQueue = useAppSelector((state) =>
        selectNumberOfAgentsLoggedInToQueue(state, queueKey),
    );

    const selectOwnUserIsLoggedInToQueue = useMemo(
        makeSelectOwnUserIsLoggedInToQueue,
        [],
    );
    const ownUserIsLoggedInToQueue = useAppSelector((state) =>
        selectOwnUserIsLoggedInToQueue(state, queueKey),
    );

    const queueActiveProfileAvailable = useAppSelector((state) =>
        selectQueueActiveProfileAvailable(state, queueKey),
    );

    if (
        !queueActiveProfileAvailable ||
        isEmptyNullOrUndefined(numberOfAgentsLoggedInToQueue)
    )
        return null;

    return (
        <AgentBadge
            loggedIn={ownUserIsLoggedInToQueue}
            className={twMerge(
                isSelected && numberOfAgentsLoggedInToQueue > 0
                    ? 'bg-gray-300'
                    : null,
            )}
        >
            {numberOfAgentsLoggedInToQueue}
        </AgentBadge>
    );
};

export default AgentsLoggedInToQueueCount;
